<template>
    <div class="index">
        <div class="top">
            <el-steps :active="stepsActive" simple finish-status="process" process-status="finish" style="width:600px">
                <el-step title="新任务" :icon="stepsActive>0?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="作业中" :icon="stepsActive>1?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="待审核" :icon="stepsActive>2?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="已结案" :icon="stepsActive>3?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="取消委托" :icon="stepsActive>4?'el-icon-folder-checked':'el-icon-edit'" v-if="stepsActive==4"></el-step>

                <!-- <el-step title="新任务" :icon="humanStatusActive>0?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="查勘中" :icon="humanStatusActive>1?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="查勘审核" :icon="humanStatusActive>2?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="查勘退回" :icon="humanStatusActive>3?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="人伤跟踪" :icon="humanStatusActive>4?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="方案制作中" :icon="humanStatusActive>5?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="方案审核" :icon="humanStatusActive>6?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="审核退回" :icon="humanStatusActive>7?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="协议签署中" :icon="humanStatusActive>8?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="任务完成" :icon="humanStatusActive>9?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="取消委托" :icon="humanStatusActive>10?'el-icon-folder-checked':'el-icon-edit'"></el-step> -->
            </el-steps>
            <div>
                <!-- <el-button type="primary" icon="el-icon-edit-outline" size="medium" v-if="stepsActive==2" @click="submitAudit(detailData.caseType==1?'提交审核':'完成')">{{detailData.caseType==1?'提交审核':'完成'}}</el-button> -->
                <el-button type="primary" icon="el-icon-edit-outline" size="medium" v-if="stepsActive==2" @click="submitAudit('完成')">完成</el-button>

                <el-button type="warning" icon="el-icon-edit-outline" size="medium" @click="addHumanTrack" v-if="humanStatusActive!=10">人伤跟踪</el-button>
            </div>
        </div>
        <div class="taskreason" v-if="stepsActive==2&&reason">
            <span>*</span>
            审核退回原因： 
            {{reason}}
        </div>
        <div class="index-content">
            <div class="index-item">
                <div class="title">
                    案件信息
                </div>
                <div class="content">
                    <div class="citem">
                        <div class="label">
                            委托主体
                        </div>
                        <el-input v-model="detailData.wtzt" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>
                    <div class="citem">
                        <div class="label">
                            委托时间
                        </div>
                        <el-date-picker
                            v-model="detailData.creationTime"
                            type="date"
                            format="yyyy-MM-dd"
                            size="small"
                            class="citem-input"
                            placeholder="选择日期">
                        </el-date-picker>
                        <!-- <el-input v-model="detailData.creationTime" placeholder="请输入" size="small" class="citem-input"></el-input> -->
                    </div>
                    <div class="citem">
                        <div class="label">
                            报案号
                        </div>
                        <el-input v-model="detailData.caseNo" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>

                    <div class="citem">
                        <div class="label">
                            案件类型
                        </div>
                        <el-select v-model="detailData.caseType" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyType">
                            <el-option
                            v-for="item in caseTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <!-- <el-input v-model="detailData.caseTypeStr" placeholder="请输入" size="small" class="citem-input"></el-input> -->
                    </div>
                    
                    <div class="citem">
                        <div class="label">
                            案发地区
                        </div>
                        <el-cascader
                            size="small"
                            :options="options"
                            v-model="crimeCityCode"
                            @change="handleRegionChange">
                        </el-cascader>
                        <!-- <el-input v-model="detailData.zhengJianNo" placeholder="请输入" size="small" class="citem-input"></el-input> -->
                    </div>
                    <div class="citem">
                        <div class="label">
                            案发地点
                        </div>
                        <el-input v-model="detailData.address" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>
                    <div class="citem">
                        <div class="label">
                            联系人
                        </div>
                        <el-input v-model="detailData.contacts" placeholder="" size="small" class="citem-input"></el-input>
                    </div>
                    <div class="citem">
                        <div class="label">
                            联系人电话
                        </div>
                        <el-input v-model="detailData.contactsPhone" placeholder="" size="small" class="citem-input"></el-input>
                    </div>
                    <div class="citem">
                        <div class="label">
                            联系人地址
                        </div>
                        <el-input v-model="detailData.contactsAddress" placeholder="" size="small" class="citem-input"></el-input>
                    </div>
                    <div class="citem">
                        <div class="label">
                            标的责任
                        </div>
                        <el-input v-model="detailData.targetLand" placeholder="请输入" size="small" class="citem-input"></el-input>
                        
                    </div>
                    <div class="citem">
                        <div class="label">
                            标准公估费
                        </div>
                        <div class="citem-value">
                            <el-input v-model="detailData.fee" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                    </div>

                    <div class="citem">
                        <div class="label">
                            实收公估费
                        </div>
                        <div class="citem-value">
                            <el-input v-model="detailData.ssFee" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                    </div>
                    <div class="citem">
                        <div class="label">
                            总作业费
                        </div>
                        <div class="citem-value">
                            <el-input v-model="detailData.operatorFees" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                            <!-- <el-button type="primary" size="small" v-if="stepsActive!=4" @click="updatePiccHumanFee">修改</el-button> -->
                        </div>
                    </div>
                    
                    <div class="citem">
                        <div class="label">
                            主案件状态
                        </div>
                        <div class="citem-value">
                            <el-input v-model="detailData.piccStatusStr" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                        </div>
                    </div>
                    <div class="citem">
                        <div class="label">
                            财务状态
                        </div>
                        <div class="citem-value">
                            <el-input v-model="detailData.financialStatusStr" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                        </div>
                    </div>
                    <div class="citem">
                        <div class="label">
                            案件状态
                        </div>
                        <div class="citem-value">
                            <el-select v-model="detailData.piccHumanStatus" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyType">
                                <el-option
                                v-for="item in piccHumanStatusList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    
                    <div class="citem">
                        <div class="label">
                            车牌号
                        </div>
                        <div class="citem-value">
                            <el-input v-model="detailData.carNo" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                        </div>
                    </div>
                    <div class="citem">
                        <div class="label">
                            车险查勘员
                        </div>
                        <div class="citem-value">
                            <el-input v-model="detailData.survey" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                        </div>
                    </div>
                    <div class="citem">
                        <div class="label">
                            车险查勘员手机
                        </div>
                        <div class="citem-value">
                            <el-input v-model="detailData.surveyPhone" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                        </div>
                    </div>
                    

                    <div class="citem citem-textarea" style="width:780px">
                        <div class="label">
                            查勘备注:
                        </div>
                        <el-input v-model="detailData.tip" placeholder="请输入" size="small" class="citem-input" rows="2" type="textarea" style="width:643px" disabled></el-input>
                    </div>
                    <div class="citem citem-textarea" style="width:780px">
                        <div class="label">
                            未决备注:
                        </div>
                        <el-input v-model="detailData.wjtip" placeholder="请输入" size="small" class="citem-input" rows="2" type="textarea" style="width:643px" disabled></el-input>
                    </div>
                </div>
            </div>
            <div class="index-table">
                <el-table
                    :data="remarkLogData"
                    border
                    :header-cell-style="tableHeaderColor"
                    height="330px"
                    style="width: 100%">
                    <el-table-column
                    prop="_operator"
                    label="创建人"
                    align="center"
                    width="180px"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="trackMsg"
                    label="跟踪备注"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="nextTrackTime"
                    label="下一次跟踪时间"
                    align="center"
                    width="180px"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="trackTime"
                    label="创建时间"
                    align="center"
                    width="180px"
                    >
                    </el-table-column>
                    
                </el-table>
                <div class="index-item">
                    <div class="citem citem-textarea" style="width:780px">
                        <div class="label">
                            派工备注:
                        </div>
                        <el-input v-model="detailData.remark" placeholder="请输入" size="small" class="citem-input" rows="5" type="textarea" style="width:643px" disabled></el-input>
                    </div>
                </div>
                <div class="index-item">
                    <div class="citem citem-textarea" style="width:780px">
                        <div class="label">
                            备注:
                        </div>
                        <el-input v-model="detailData.cRemark" placeholder="请输入" size="small" class="citem-input" rows="4" type="textarea" style="width:643px"></el-input>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="editbtns" v-if="stepsActive<9">
            <el-button type="primary" icon="el-icon-edit" @click="updateCase">修改案件信息</el-button>
        </div>
        
        
        
        <el-tabs type="border-card" class="card" @tab-click="tabSelect">
            <el-tab-pane>
                <span slot="label"><i class="el-icon-date"></i> 伤者信息</span>
                <div class="btns" v-if="stepsActive==0||stepsActive==1||stepsActive==2">
                    <el-button type="primary" icon="el-icon-circle-plus" @click="addWoundedInformation">添加伤者信息</el-button>
                </div>
                <el-table
                    :data="humanData"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    <el-table-column
                    type="index"
                    width="55"
                    label="序号"
                    align="center"
                    >
                    </el-table-column>

                    <el-table-column
                    prop="name"
                    label="伤者姓名"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="phone"
                    label="联系电话"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="humanType"
                    label="伤者类型"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="humanShenFen"
                    label="伤者身份"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="guiShuCar"
                    label="归属车辆"
                    align="center"
                    >
                    </el-table-column>
                    <!-- <el-table-column
                    prop="operator"
                    label="作业机构"
                    align="center"
                    >
                    </el-table-column> -->
                    
                    <el-table-column
                    prop="operator"
                    label="查勘员"
                    align="center"
                    >
                        <template slot-scope="scope">
                            {{scope.row.operator?scope.row.operator:"暂无"}}
                        </template>
                    </el-table-column>
                   
                    <el-table-column
                    prop="tjy"
                    label="调解员"
                    align="center"
                    >
                        <template slot-scope="scope">
                            {{scope.row.tjy?scope.row.tjy:"暂无"}}
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="humanStatus"
                    label="伤者任务状态"
                    align="center"
                    >
                        <template slot-scope="scope">
                            {{scope.row.humanStatus==0?"待接收":""}}
                            {{scope.row.humanStatus==10?"查勘中":""}}
                            {{scope.row.humanStatus==20?"查勘审核":""}}
                            {{scope.row.humanStatus==30?"查勘退回":""}}
                            {{scope.row.humanStatus==40?"查勘完成":""}}
                            {{scope.row.humanStatus==50?"调解员未接收":""}}
                            {{scope.row.humanStatus==60?"方案制作中":""}}
                            {{scope.row.humanStatus==70?"方案审核":""}}
                            {{scope.row.humanStatus==72?"调解退回":""}}
                            {{scope.row.humanStatus==75?"协议签署中":""}}
                            {{scope.row.humanStatus==80?"任务完成":""}}
                        </template>
                    </el-table-column>

                    <el-table-column
                    prop="isjsck"
                    label="是否及时查勘"
                    align="center"
                    >
                        <template slot-scope="scope">
                            {{scope.row.isjsck===true?"是":""}}
                            {{scope.row.isjsck===false?"否":""}}
                            {{scope.row.isjsck==null?"/":""}}
                        </template>
                    </el-table-column>

                    <el-table-column
                    prop="isckclqq"
                    label="查勘材料是否齐全"
                    align="center"
                    >
                        <template slot-scope="scope">
                            {{scope.row.isckclqq===true?"是":""}}
                            {{scope.row.isckclqq===false?"否":""}}
                            {{scope.row.isckclqq==null?"/":""}}
                        </template>
                    </el-table-column>

                    <el-table-column
                    fixed="right"
                    label="操作"
                    width="220px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <!-- {{scope.row.humanStatus}}
                            {{detailData.caseType}}
                            {{humanStatusActive}} -->
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="editHuman(scope.row)" v-if="scope.row.humanStatus<20&&humanStatusActive!=10">编辑任务</el-button>
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="detailHuman(scope.row)" v-else>查看任务</el-button>
                        <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteHumanTip(scope.row)" v-if="scope.row.humanStatus<20&&humanStatusActive!=10">删除</el-button>
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="audit(scope.row)" v-if="scope.row.humanStatus==20&&humanStatusActive!=10">查勘审核</el-button>
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="completeAuditTip(scope.row)" v-if="scope.row.humanStatus!=80&&detailData.caseType==1">任务完成</el-button>
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="audit2(scope.row)" v-if="scope.row.humanStatus==70&&humanStatusActive!=10">方案审核</el-button>
                        <el-button type="text" icon="el-icon-document-checked" size="mini" @click="mediateDialog(scope.row)" v-if="scope.row.humanStatus==40&&detailData.caseType==1&&humanStatusActive!=10">
                            接受调解
                        </el-button>
                         
                    </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane>
                <span slot="label"><i class="el-icon-date"></i> 作业负责人</span>
                <!-- <div class="btns">
                    <el-button type="primary" icon="el-icon-circle-plus" @click="isAddOrganizationDialog = true">指派作业机构</el-button>
                </div> -->
                <el-table
                    :data="organizationData"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    <el-table-column
                    type="index"
                    width="55"
                    label="序号"
                    align="center"
                    >
                    </el-table-column>

                    <el-table-column
                    prop="dispatch"
                    label="负责人名称"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="creationTime"
                    label="派工时间"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="afd"
                    label="案发地机构"
                    align="center"
                    >
                    <template slot-scope="scope">
                        {{scope.row.afd?'是':'否'}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop="remark"
                    label="派案备注"
                    align="center"
                    >
                    </el-table-column>
                    
                    <!-- <el-table-column
                    fixed="right"
                    label="操作"
                    width="100px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="delOrganizationTip(scope.row)">删除</el-button>
                    </template>
                    </el-table-column> -->
                </el-table>
            </el-tab-pane>
            <el-tab-pane>
                <span slot="label"><i class="el-icon-date"></i> 现场查勘资料</span>
                <div class="btns">
                    <el-button type="primary" icon="el-icon-download" @click="downFileCarPicByCaseId">下载查勘资料</el-button>
                </div>
                <div class="section-item" v-for="(mitem,mindex) in materialList" :key="mindex">
                    <div class="stitle">
                        {{mitem.name}}
                    </div>
                    <div class="materiallist">
                        <transition-group>
                            <div class="material" v-for="(item,index) in mitem.picurlList" :key="index" v-if="item.path">
                                <img src="../../../assets/images/icon11.png" alt="" v-if="item.type=='mp3'||item.type=='aac'||item.type=='wav'||item.type=='wma'||item.type=='flac'||item.type=='ape'" :fit="cover" @click="download(item.path)">
                                <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.type=='rmvb'||item.type=='rm'||item.type=='ts'||item.type=='tp'||item.type=='avi'||item.type=='3gp'||item.type=='mp4'||item.type=='mkv'" :fit="cover" @click="download(item.path)">
                                <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.type=='xls'||item.type=='xlsx'||item.type=='doc'||item.type=='docx'||item.type=='ppt'||item.type=='pptx'||item.type=='pdf'||item.type=='zip'||item.type=='rar'" :fit="cover" @click="download(item.path)">
                                <el-image
                                style="width: 120px; height: 120px"
                                :src="item.path"
                                v-else-if="item.type=='jpg'||item.type=='png'||item.type=='gif'||item.type=='jpeg'"
                                @click="showImg(item.path,mitem.picurlList)"
                                :fit="cover"></el-image>
                            </div>
                        </transition-group>
                        
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane>
                <span slot="label"><i class="el-icon-date"></i> 案件日志</span>
                <!-- <div class="btns">
                    <el-button type="primary" icon="el-icon-circle-plus">主要按钮</el-button>
                </div> -->
                <el-table
                    :data="logData"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    <el-table-column
                    type="index"
                    width="55"
                    label="序号"
                    align="center"
                    >
                    </el-table-column>

                    
                    <el-table-column
                    prop="operator"
                    label="操作人"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="content"
                    label="日志内容"
                    align="center"
                    width="300px"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="creationTime"
                    label="创建时间"
                    align="center"
                    >
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>



        

        

        
        <el-dialog :close-on-click-modal="false" :visible.sync="isAddOrganizationDialog" title="指派机构" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        指派机构：
                    </div>
                    <div class="value" style="width:400px">
                        <el-input v-model="addOrganizationData.mechanism" placeholder="请输入" size="small" disabled></el-input>
                        <el-button type="primary" size="small" icon="el-icon-edit-outline" @click="isMechanismDialog = true">选择</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        派工备注:
                    </div>
                    <div class="value" style="width:500px">
                        <el-input v-model="addOrganizationData.remark" placeholder="请输入" size="small" type="textarea"></el-input>
                    </div>
                </div>
                <div class="dialog-footer">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="affirmMechanism">确定</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isMechanismDialog" title="选择机构" width="800px">
            <el-table
            ref="multipleTable"
            :data="mechanismList"
            border
            :header-cell-style="tableHeaderColor"
            @selection-change="handleSelectionMechanismChange"
            style="width:100%"
            height="400px"
            >
           
            <el-table-column
            type="index"
            label="序号"
            width="60"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="name"
            label="机构名称"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="code"
            label="所在地区"
            align="center"
            >
            <template slot-scope="scope">
                {{scope.row.province}}
                {{scope.row.city}}
                {{scope.row.district}}
            </template>

            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="150px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="primary" @click="selectMechanism(scope.row)" icon="el-icon-edit-outline">确 定</el-button>
                </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                @current-change="handleCurrentChangeMechanism"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCountMechanism"
                    :current-page="conditionDataMechanism.page"
                    :page-size="conditionDataMechanism.pageSize">
                </el-pagination>
            </div>
            <div class="footer" style="margin-top:20px">
                <el-button icon="el-icon-circle-close" @click="isMechanismDialog=false">关 闭</el-button>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isRemarkLogDialog" title="人伤跟踪" width="740px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        跟踪次数:
                    </div>
                    <div class="value" style="width:200px">
                        {{trackNumber}}
                        <!-- <el-input v-model="remarkLog" placeholder="请输入" type="textarea" style="width:500px"></el-input> -->
                    </div>
                </div>
                <div class="item" >
                    <div class="label">
                        下一次跟踪日期:
                    </div>
                    <div class="value" style="width:500px">
                        <el-date-picker
                        v-model="trackData.nextTrackTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        人伤跟踪记录:
                    </div>
                    <div class="value" style="width:500px">
                        <el-input v-model="trackData.trackMsg" placeholder="请输入" type="textarea" style="width:500px" :rows="4"></el-input>
                    </div>
                </div>
                
                <div class="dialog-footer">
                    <el-button type="primary" icon="el-icon-edit" @click="insertLog()">确定</el-button>
                </div>
            </div>
        </el-dialog>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isAcceptMediationDialog" title="接受调解" width="900px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        指派调解员:
                    </div>
                    <div class="value">
                        <el-select v-model="mediateData.tjyId" size="small" placeholder="请选择"  class="citem-input" @change="changeTjyId" filterable>
                            <el-option
                            v-for="item in personList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                
                <div class="dialog-footer">
                    <el-button type="primary" icon="el-icon-edit" @click="mediate()">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
    </div>
</template>
<script>
import api from '../../../api/main'
import {parseTimeD,updateTrackingDate} from '../../../utils/index'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { regionDataPlus , provinceAndCityData , CodeToText , TextToCode } from "element-china-area-data";
import {CaseTypeList,PiccHumanStatusList } from '../../../assets/selectList/index'

export default {
    name: 'index',
    components:{
        ElImageViewer
    },
    watch: {
    },
    data () {
        return {
            piccHumanStatusList:PiccHumanStatusList,
            isAcceptMediationDialog:false,
            caseTypeList:CaseTypeList,
            detailData:{
                
            },
            options:provinceAndCityData,
            crimeCityCode:[],
            uploadUrl:'',

           


            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,

            allNum:0,
            finishNum:0,

            stepsActive:0,
            crimeCityCode:[],

            humanData:[],
            organizationData:[],
            addOrganizationData:{},
            isAddOrganizationDialog:false,

            mechanismList:[],
            isMechanismDialog:false,
            selectMechanismList:[],
            conditionDataMechanism:{
                page:1,
                pageSize:10,
            },
            totalCountMechanism:0,
            reason:'',
            logData:[],
            remarkLogData:[],

            remarkLog:'',
            isRemarkLogDialog:false,
            addRemark:'',
            personList:[],


            isAcceptMediationDialog:false,
            mediateData:{},

            trackData:{
                "piccHumanTaskId": null,
                "trackMsg": "",
                "nextTrackTime": null,
                // "trackTime": "2022-02-20T06:33:46.354Z"
            },
            nowDate:null,
            trackNumber:0,
            trackTime:null,


            humanStatusActive:0,
            materialList:[],

        }
    },
    created(){
        
        let nowDate = new Date();
        this.nowDate = nowDate.getFullYear() + '-' + (nowDate.getMonth() + 1) + '-' + nowDate.getDate();
        console.log(this.nowDate);

    },
    mounted(){
        console.log(this.options);

        this.getDetailData();
        this.getTaskDetailData();
        this.queryHuman();
        
        this.queryMechanism();
        this.queryUserByMechanismIds();
        this.queryTrackMsgListByHumanId();

        this.organizationList();

        for(let index in this.options){
            if(this.options[index].label=='客服部'){
                this.options[index].disabled = true
            }
            if(this.options[index].label=='后援中心'){
                this.options[index].disabled = true
            }
        }
    },
    methods:{
        async downFileCarPicByCaseId(){
            let res = await api.downFileCarPicByCaseId(this.detailData.caseId,this.detailData.caseNo);
        },
        async updateCase(){
            this.detailData.targetLand = parseFloat(this.detailData.targetLand)
            this.detailData.fee = parseFloat(this.detailData.fee)
            let res = await api.piccHumanUpdate(this.detailData);
            console.log(res);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '修改成功！'
                });
                this.getTaskDetailData();
            }
        },
       
        // 查询机构人员
        async queryUserByMechanismIds(){
            let res = await api.queryUserByMechanismIds({
                pageSize:1000,
            });
            this.personList = res.data.data;
        },
        // 接受案件
        mediateDialog(row){
            console.log(this.organizationData[0]);
            this.isAcceptMediationDialog = true;
            this.mediateData.humanId = row.id;
            this.mediateData.tjyId = this.organizationData[0].dispatchId;
            this.mediateData.tjy =  this.organizationData[0].dispatch;
            this.$forceUpdate();
            // this.$confirm('将接受调解, 是否继续?', '提示', {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            // }).then(() => {
            //     this.mediateData.humanId = row.id;
            //     this.mediate(row);
            // }).catch(() => {
            //     this.$message({
            //         type: 'info',
            //         message: '已取消退出'
            //     });          
            // });
        },
        async mediate(row){
            let res = await api.assignTjHuman(this.mediateData);
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '案件确认可调解！'
                });
                this.isAcceptMediationDialog = false;
                this.updateHumanStatus(60,this.mediateData.humanId);

            }
        },
        // 更新人员任务状态
        async updateHumanStatus(status,humanId){
            let res = await api.updateHumanStatus({
                humanId:humanId,
                humanStatus:status,
            });
            if(res.data.code=='200'){
                this.queryHuman();
            }
        },
        async updateTaskStatus(status){
            let res = await api.updateTaskStatus({
                piccHumanTaskId:this.$route.query.taskId,
                taskStatus:status,
            });
            if(status==10){
                this.stepsActive = 1;
            }
            if(res.data.code=='200'){
                if(status==30){
                    this.$message({
                        type: 'success',
                        message: '提交审核成功!'
                    });
                    this.updatePiccHumanStatus(30);
                }

            }
        },
        // 选择机构
        selectMechanism(row){
            this.addOrganizationData.mechanismId = row.id;
            this.addOrganizationData.mechanism = row.name;
            this.isMechanismDialog = false;
        },
        // 机构列表
        async queryMechanism(){
            let res = await api.QueryMechanism(this.conditionDataMechanism);
            this.mechanismList = res.data.data.data;
            this.totalCountMechanism = res.data.data.totalCount;
        },
        // 切换
        handleCurrentChangeMechanism(page){
            this.conditionDataMechanism.page = page;
            this.queryMechanism();
        },
        // 伤者信息列表
        async queryHuman(){
            let res = await api.queryHumanByPiccHumanId(this.$route.query.id);
            this.humanData = res.data.data;
            if(this.humanData.length == 0){
                this.humanStatusActive = 0;
            }

            let status = null;
            for(let index in this.humanData){
                if(index == 0){
                    status = this.humanData[index].humanStatus
                }else{
                    if(status>this.humanData[index].humanStatus){
                        status = this.humanData[index].humanStatus
                    }
                }  
            }
            if(status == 0){
                this.humanStatusActive = 0;
            }
            else if(status == 10){
                this.humanStatusActive = 1;
            }
            else if(status == 20){
                this.humanStatusActive = 2;
            }
            else if(status == 30){
                this.humanStatusActive = 3;
            }
            else if(status == 40){
                this.humanStatusActive = 4;
            }
            else if(status == 60){
                this.humanStatusActive = 5;
            }
            else if(status == 70){
                this.humanStatusActive = 6;
            }
            else if(status == 72){
                this.humanStatusActive = 7;
            }
            else if(status == 75){
                this.humanStatusActive = 8;
            }
            else if(status == 80){
                this.humanStatusActive = 9;
            }
           
            if(this.detailData.piccHumanStatus==-1){
                this.humanStatusActive = 10;
            }
            if(this.detailData.piccHumanStatus==40){
                this.humanStatusActive = 9;
            }
           

        },
        // 删除伤者信息
        deleteHumanTip(row){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteHuman(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        // 任务完成
        async completeAuditTip(row){
            this.$confirm('将完成任务, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.completeAudit(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async completeAudit(row){
            let res = await api.updateHumanStatus({
                "humanId": row.id,
                "humanStatus": 80,
            });
            if(res.data.code=='200'){
                this.isNoAuditDialog = false;
                this.$message({
                    type: 'success',
                    message: '操作完成！'
                });  
                this.queryHuman();
            }
        },
        
        async deleteHuman(row){
            console.log(row);
            let res = await api.deleteHuman(row.id);
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });  
                this.queryHuman();    
            }
        },
        // 指派机构
        async affirmMechanism(){
            this.addOrganizationData.piccHumanId = this.$route.query.id;
            let res = await api.piccHumanTaskAdd(this.addOrganizationData);
            if(res.data.code == '200'){
                this.isAddOrganizationDialog = false;
                this.addOrganizationData = {};

                if(this.stepsActive==1){
                    this.updateTaskStatus(20);
                }
                this.organizationList();
            }
        },
        // 删除指派机构
        async delOrganizationTip(){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 选择机构
        handleRegionChange(codeArray){
            console.log(codeArray);
            
            if(codeArray[0]){
                this.detailData.province = CodeToText[codeArray[0]]
            }
            if(codeArray[1]){
                this.detailData.city = CodeToText[codeArray[1]]
            }
        },
        
        
        // 查看详情
        async getDetailData(){
            let res = await api.piccHumanQueryByPiccHumanId(this.$route.query.id);

            console.log('resresresresresres');
            console.log(res);
            this.detailData = res.data.data;
            if(this.detailData.piccHumanStatus == 0){
            }else if(this.detailData.piccHumanStatus == 10){
                this.stepsActive = 0;
            }else if(this.detailData.piccHumanStatus == 20||this.detailData.piccHumanStatus == 25){
                this.stepsActive = 1;
            }else if(this.detailData.piccHumanStatus == 30){
                this.stepsActive = 2;
            }else if(this.detailData.piccHumanStatus == 40){
                this.stepsActive = 3;
                // this.reason = this.detailData.reason;
            }else if(this.detailData.piccHumanStatus == -1){
                this.stepsActive = 4;
            }
            this.detailData.caseTypeStr = this.detailData.caseType==1?'全流程':'首勘';
            if(this.detailData.piccStatus==1){
                this.detailData.piccStatusStr='案件未完成'
            }
            else if(this.detailData.piccStatus==2){
                this.detailData.piccStatusStr='已核损待结案'
            }
            else if(this.detailData.piccStatus==3){
                this.detailData.piccStatusStr='已结案'
            }
            if(this.detailData.financialStatus==0){
                this.detailData.financialStatusStr='无'
            }
            else if(this.detailData.financialStatus==1){
                this.detailData.financialStatusStr='已开票未回款'
            }
            else if(this.detailData.financialStatus==2){
                this.detailData.financialStatusStr='已开票部分回款'
            }
            else if(this.detailData.financialStatus==3){
                this.detailData.financialStatusStr='回款完成'
            }
            else if(this.detailData.financialStatus==4){
                this.detailData.financialStatusStr='已回款未开票'
            }
            else if(this.detailData.financialStatus==5){
                this.detailData.financialStatusStr='其他'
            }
            if(TextToCode[this.detailData.province]&&TextToCode[this.detailData.province][this.detailData.city]){
                this.crimeCityCode = [TextToCode[this.detailData.province].code,TextToCode[this.detailData.province][this.detailData.city].code];
            }
            if(this.detailData.piccHumanStatus==-1){
                this.humanStatusActive = 10;
                this.stepsActive = 5;
            }else{
                this.queryHuman();
            }
           
           
        },
        // 案件任务详情
        async getTaskDetailData(){
            let res = await api.queryPiccHumanTaskByPiccHumanId(this.$route.query.id);
            let rdata = res.data.data;
            // if(rdata[0].taskStatus == 0){
            // }else if(rdata[0].taskStatus == 10){
            //     this.stepsActive = 1;
            // }else if(rdata[0].taskStatus == 20){
            //     this.stepsActive = 2;
            // }else if(rdata[0].taskStatus == 30){
            //     this.stepsActive = 3;
            // }else if(rdata[0].taskStatus == 40){
            //     this.stepsActive = 2;
            //     this.reason = rdata[0].reason;
            // }else if(rdata[0].taskStatus == 50){
            //     this.stepsActive = 4;
            // }
            this.getDetailData();

        },
        // tab切换
        async tabSelect(e){
            console.log(e.index);
            if(e.index==0){
                this.queryHuman();
            }else if(e.index==1){
                this.organizationList();
            }else if(e.index==2){
                this.queryCarPicByCaseId();
            }else if(e.index==3){
                this.logList(0);
            }
        },
        async queryCarPicByCaseId(){
            this.materialList = [];
            let res = await api.queryCarPicByCaseId(this.detailData.caseId);
            let materialList = res.data.data;
            for(let i in materialList){
                this.materialList.push({
                    name:materialList[i].name,
                    picurlList:[]
                })
                for(let j in materialList[i].picurlList){
                    let typeList = materialList[i].picurlList[j].split('.');
                    this.materialList[i].picurlList.push({
                        type:typeList[typeList.length-1],
                        path:materialList[i].picurlList[j]
                    })
                }
            }
        },
        // 机构列表
        async organizationList(){
            let res = await api.queryPiccHumanTaskByPiccHumanId(this.$route.query.id);
            this.organizationData = res.data.data;
        },

        // 上传
        async upload(file){
            let res = await api.uploadOther(file.file);
            console.log(res);
            this.addDocData.path = res;
            this.$forceUpdate();
        },
        // 下载
        download(path,name){
            this.$message({
                type: 'success',
                message: '下载成功,请稍等!'
            });
            const elt = document.createElement('a');
            elt.setAttribute('target', '_blank');
            elt.setAttribute('href', path);
            elt.setAttribute('download', name);
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },

        // 添加伤者
        addWoundedInformation(){
            this.$router.push({
                name:'addWoundedInformation',
                query:{
                    id:this.$route.query.id,
                    taskId:this.$route.query.taskId,
                    humanStatusActive:this.humanStatusActive
                }
            })
        },

        // 编辑伤者
        editHuman(row){
            this.$router.push({
                name:'editWoundedInformation',
                query:{
                    id:this.$route.query.id,
                    humanId:row.id,
                    humanStatusActive:this.humanStatusActive

                }
            })
        },
        detailHuman(row){
            const { href } = this.$router.resolve({
                name: "woundedInformationDetail",
                query:{
                    id:this.$route.query.id,
                    humanId:row.id,
                    isNoEdit:1,
                    humanStatusActive:this.humanStatusActive,
                    name:row.name,
                }
            });
            window.open(href, '_blank');
            // this.$router.push({
            //     name:'editWoundedInformation',
            //     query:{
            //         id:this.$route.query.id,
            //         humanId:row.id,
            //         isNoEdit:1,
            //         humanStatusActive:this.humanStatusActive

            //     }
            // })
        },
        // 审核案件
        audit(row){
            this.$router.push({
                name:'audit',
                query:{
                    id:this.$route.query.id,
                    humanId:row.id,
                    humanStatusActive:this.humanStatusActive,
                }
            })
        },
        // 审核案件
        audit2(row){
            this.$router.push({
                name:'audit2',
                query:{
                    id:this.$route.query.id,
                    humanId:row.id,
                    humanStatusActive:this.humanStatusActive,
                }
            })
        },

        // 提交审核
        async submitAudit(txt){
            this.$confirm('将'+txt+'案件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.submitAuditApi();
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        async submitAuditApi(){
            // if(this.detailData.caseType==1){
            //     for(let i in this.humanData){
            //         if(this.humanData[i].humanStatus!=80){
            //             this.$message({
            //                 type: 'error',
            //                 message: '存在调解任务未完成!'
            //             });
            //             return;
            //         }
            //     }
            //     this.updateTaskStatus(30);
            // }else{
            // }
            this.completePiccHumanTask();
        },
        // 修改任务状态
        async updatePiccHumanStatus(status){
            let res = await api.updatePiccHumanStatus({
                piccHumanId:this.$route.query.id,
                piccHumanStatus:status,
            });
            if(res.data.code == '200'){
                this.getTaskDetailData()
            }
            
        },
        // 日志列表
        async logList(type){
            let res = await api.queryLogByPiccHumanId({
                PiccHumanId:this.$route.query.id,
                LogType:type
            });
            if(type){
                this.remarkLogData = res.data.data;
            }else{
                this.logData = res.data.data;
            }
        },
        
        async queryTrackMsgListByHumanId(){
            let res = await api.queryTrackMsgListByHumanId(
                this.$route.query.taskId,
            );
            this.trackNumber = res.data.data.trackNum;
            this.trackTime = res.data.data.nextTrackTime;
            if(!res.data.data.taskTrackMsgList){
                this.remarkLogData = [];
            }else{
                this.remarkLogData = res.data.data.taskTrackMsgList;
            }

        },
        
        addHumanTrack(){
            if(this.trackNumber==0){
                let trackTime = new Date();
                this.trackTime = trackTime.getFullYear() + '/' + (trackTime.getMonth() + 1) + '/' + trackTime.getDate()
            }
            this.trackData.nextTrackTime = updateTrackingDate(this.trackNumber,this.trackTime)
            this.isRemarkLogDialog = true;
        },
        // 添加日志
        async insertLog(){
            let res = await api.addTrackMsg({
                piccHumanTaskId:this.$route.query.taskId,
                trackMsg:this.trackData.trackMsg,
                nextTrackTime:this.trackData.nextTrackTime,
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '添加成功!'
                });
                this.trackData.nextTrackTime = "";
                this.trackTime = "";
                this.trackData.trackMsg = "";
                this.isRemarkLogDialog = false;
                // this.remarkLog = "";
                this.queryTrackMsgListByHumanId();
            }
        },
        // 修改调解人人Id
        async changeTjyId(e){
            for(let index in this.personList){
                if(this.personList[index].id==e){
                    this.mediateData.tjy =  this.personList[index].name;
                }
            }
        },

        // 编辑案件公估费
        async updatePiccHumanFee(){
            let res = await api.updatePiccHumanFee({
                "piccHumanId":this.$route.query.id,
                "fee": parseFloat(this.detailData.fee)
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '编辑成功!'
                });
            }
        },

        // 完成
        async completePiccHumanTask(){
            let res = await api.completePiccHumanTask({
                piccHumanId:this.$route.query.id,
                piccHumanTaskId:this.$route.query.taskId,
            });
            if(res.data.code=='200'){
                this.getTaskDetailData();
                this.$message({
                    type: 'success',
                    message: '提交审核成功!'
                });
            }
        },

        showImg(img,list){
            let imglist = [];
            for(let i in list){
                if(list[i].type=='jpg'||list[i].type=='png'||list[i].type=='gif'||list[i].type=='jpeg'||list[i].type=='JPG'||list[i].type=='PNG'||list[i].type=='GIF'||list[i].type=='JPEG'){
                    imglist.push(list[i].path);
                    if(img==list[i].path){
                        this.imgIndex = imglist.length-1
                    }
                }
            }
            this.showBigImgList = imglist;
            this.showBigImg = true;
        },
        closeViewer(){
            this.showBigImg = false;
        }
    }
    
}
</script>

<style lang="scss" scoped>
    /deep/.el-textarea.is-disabled .el-textarea__inner{
        color: #606266;
    }
    .top{
        height: 40px;
        display: flex;
        justify-content: space-between;
        padding:10px;
        background-color: #ffffff;
        z-index: 60;
        /deep/.el-step__title{
           font-weight: bold; 
        }
        /deep/.el-steps--simple{
            padding: 13px 0px;
        }
    }
    .taskreason{
        span{
            color: red;
            font-size: 18px;
        }
        font-size: 14px;
        margin: 10px 0;
    }

    .editbtns{
        display: flex;
        justify-content: center;
        padding-bottom: 10px;
    }

    .index{
        .index-content{
            min-width: 1700px;
            display: flex;
        }
        .index-item{
            width: 800px;
            border: 1px solid #eee;
            box-shadow: 0 1px 4px rgbe(0,21,41,8%);
            display: flex;
            flex-wrap: wrap;
            padding:2px 15px;
            padding-top: 15px;
            margin-bottom: 10px;
            padding-right: 0px;
            background-color: #ffffff;
            margin-top: 10px;
            border-radius: 10px;
            .title{
                width: 100%;
                font-weight: bold;
                font-size: 18px;
                margin-bottom: 20px;
            }
            .content{
                min-width: 900px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                .checkbox{
                    margin-right: 40px;
                    margin-bottom: 10px;
                    /deep/.el-checkbox__label{
                        font-size: 14px;
                        color: #000000;
                    }
                }
                
            }

            .citem{
                display: flex;
                align-items: center;
                margin-right: 15px;
                padding-bottom: 10px;
                width: 380px;
                .label{
                    width: 110px;
                    font-size: 15px;
                }
                .citem-value{
                    width: 250px;
                    display: flex;
                    align-items: center;
                }
                .value{
                    border: 1px solid #DCDFE6;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #606266;
                    line-height: 24px;
                    padding: 5px 10px;
                    background-color: #ffffff;
                }
                .value-scroll{
                    height: 120px;
                    overflow-y: scroll;
                }
                .citem-input{
                    width: 250px;
                }
                /deep/.el-tag--medium{
                    height: 42px;
                    line-height: 42px;
                    margin-right: 10px;
                }
            }
            
        }
        .index-table{
            flex: auto;
            padding-top: 10px;
            padding-left: 10px;
        }
        .card{
            .content{
                min-width: 900px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                .checkbox{
                    margin-right: 40px;
                    margin-bottom: 10px;
                    /deep/.el-checkbox__label{
                        font-size: 14px;
                        color: #000000;
                    }
                }
                .citem{
                    display: flex;
                    align-items: center;
                    margin-right: 25px;
                    padding-bottom: 10px;
                    width: 380px;
                    .label{
                        width: 125px;
                    }
                    .citem-input{
                        width: 250px;
                    }
                    /deep/.el-tag--medium{
                        height: 42px;
                        line-height: 42px;
                        margin-right: 10px;
                    }
                }
                .citem-textarea{
                    width: 100%;
                    .label{
                        width: 150px;
                    }
                    .citem-input{
                        width: 750px;
                    }
                }
            }
            .btns{
                margin-bottom: 15px;
            }
        }
        .bottom{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: 20px;
        }


        .dialog{
            padding-top: 20px;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            .item{
                
                font-size: 14px;
                padding:10px 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                .label{
                    min-width: 110px;
                    margin-bottom: 5px;
                }
                .value{
                    display: flex;
                    align-items: center;
                }
                .item-input{
                    width: 340px;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    /deep/.el-input{
                        width: 320px;
                    }
                }
                .item-imgs{
                    width: 380px;
                    display: flex;
                    flex-wrap: wrap;
                    margin-top: 10px;
                    .item-img{
                        position: relative;
                        margin-right: 10px;
                        margin-bottom: 10px;
                        .icon{
                            right: 0;
                            top: 0;
                            position:absolute;
                            z-index: 100;
                            color: #ffffff;
                            background-color: #000000;
                            width: 18px;
                            height: 18px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            cursor: pointer;
                        }

                    }
                }
                /deep/.el-image{
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
                .item-textarea{
                    width: 380px;
                }
            }


            
            .dialog-footer{
                width: 100%;
                display: flex;
                justify-content: center;
                .el-button{
                    margin-top: 20px;
                }
            }
            
        }
        .dialog-t{
            padding-top: 20px;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            .item{
                
                font-size: 14px;
                padding:10px 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                .label{
                    min-width: 110px;
                    margin-bottom: 5px;
                }
                .item-input{
                    width: 340px;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    /deep/.el-input{
                        width: 320px;
                    }
                }
                .item-imgs{
                    width: 380px;
                    display: flex;
                    flex-wrap: wrap;
                    margin-top: 10px;
                    .item-img{
                        position: relative;
                        margin-right: 10px;
                        margin-bottom: 10px;
                        .icon{
                            right: 0;
                            top: 0;
                            position:absolute;
                            z-index: 100;
                            color: #ffffff;
                            background-color: #000000;
                            width: 18px;
                            height: 18px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            cursor: pointer;
                        }

                    }
                }
                /deep/.el-image{
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
                .item-textarea{
                    width: 380px;
                }
            }
            .section{
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                border: 1px solid #DEDEDE;
                margin-bottom: 15px;
                padding-bottom: 10px;
                .title{
                    width: 100%;
                    font-weight: bold;
                    font-size: 16px;
                    margin-bottom: 12px;
                    background-color: #DEDEDE;
                    padding:8px 15px;
                }
                .materiallist{
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    margin-bottom: 15px;
                    padding: 15px;
                    .material{
                        border: 1px dashed #dcdcdc;
                        width: 150px;
                        height: 170px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                        border-radius: 4px;
                        margin:10px;
                        position: relative;
                        img{
                            width: 120px;
                        }
                        .close{
                            width: 25px;
                            height: 25px;
                            position: absolute;
                            right: 3px;
                            top: 3px;
                        }
                        .filename{
                            width: 130px;
                            font-size: 12px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            text-align: center;
                            margin-top: 2px;
                        }
                    }
                }
            }
            
            .dialog-footer{
                width: 100%;
                display: flex;
                justify-content: center;
                .el-button{
                    margin-top: 20px;
                }
            }
        }
    }
    .section-item{
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #DEDEDE;
        margin-bottom: 10px;
        margin-top: 10px;
        .stitle{
            background-color: #f1f1f1;
            width: 100%;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 12px;
            border-bottom:1px solid #DEDEDE;
            padding:8px 15px;
            display: flex;
            justify-content: space-between;
        }
        .materiallist{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin-bottom: 15px;
            .material{
                border: 1px dashed #dcdcdc;
                width: 150px;
                height: 150px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                border-radius: 4px;
                margin:10px;
                position: relative;
                float: left;
                img{
                    width: 120px;
                }
                .close{
                    width: 25px;
                    height: 25px;
                    position: absolute;
                    right: 3px;
                    top: 3px;
                }
                .filename{
                    width: 130px;
                    font-size: 12px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    text-align: center;
                    margin-top: 2px;
                }
            }
        }
    }
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding-bottom: 15px;
        
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            width: 300px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    /deep/.el-step.is-simple .el-step__title{
        font-size: 15px;
    } 
    /deep/.el-step.is-simple:not(:last-of-type) .el-step__title{
        max-width: 70%;
    } 
    /deep/.el-steps--simple{
        padding:  0px;
        background-color: #ffffff;
    }
    /deep/.el-steps{
        width: 1000px;
    }
    /deep/.el-step.is-simple .el-step__arrow::after, /deep/.el-step.is-simple .el-step__arrow::before{
        height: 9px !important;
    }
    
    /deep/.el-step.is-simple .el-step__arrow::after{
        transform: rotate(45deg) translateY(3px);
    }
    /deep/.el-step.is-simple .el-step__arrow::before{
        transform: rotate(-45deg) translateY(-3px);
    }
    /deep/.el-input.is-disabled .el-input__inner{
        color:#606266;
    }
</style>
